import * as React from 'react';
import * as _ from 'lodash';
import { NavLink } from 'react-router-dom';
import { IndexLink } from 'react-router-dom';
import { Link as ToolLink } from 'react-toolbox/lib/link';
import { Layout } from 'react-toolbox';
import { NavDrawer } from 'react-toolbox';
import { Panel } from 'react-toolbox';
import { AppBar } from 'react-toolbox/lib/app_bar';
import { Navigation } from 'react-toolbox/lib/navigation';
import { IconButton } from 'react-toolbox';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import { Menu } from 'react-toolbox/lib/menu';
import { MenuItem } from 'react-toolbox/lib/menu';
import { MenuDivider } from 'react-toolbox/lib/menu';
import { Switch } from 'react-router-dom';
import { Route } from 'react-router-dom';
import NotFound from '../../../core/components/not_found';
import GuestHome from '../home';
import PracticeCreate from '../../../practice/components/practice_create';
import PracticeDetails from '../../../practice/components/practice_details';
import PracticeList from '../../../practice/components/practice_list';
export default function () {
    return React.createElement('div', { 'className': 'd-flex' }, React.createElement('div', {
        'className': 'content-zone',
        'style': {
            flex: '1',
            padding: '0px 15px'
        }
    }, React.createElement(Switch, {}, React.createElement(Route, {
        'exact': true,
        'path': `${ this.props.match.url }/home`,
        'component': GuestHome
    }), React.createElement(Route, {
        'exact': true,
        'path': `${ this.props.match.url }/practice/create`,
        'component': PracticeCreate
    }), React.createElement(Route, {
        'exact': true,
        'path': `${ this.props.match.url }/client/connect/practice/:practice_id`,
        'component': PracticeDetails
    }), React.createElement(Route, {
        'exact': true,
        'path': `${ this.props.match.url }/client/connect`,
        'component': PracticeList
    }), React.createElement(Route, {
        'exact': true,
        'path': `${ this.props.match.url }/`,
        'component': GuestHome
    }), React.createElement(Route, { 'component': NotFound }))));
}